import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import ResourceList from '../../components/ResourceList.jsx';
import ResourceForm from '../../components/ResourceForm.jsx';
import { BUSINESS_RESOURCES } from './resources';

const BASE = '/business';

/** /business/:resource — list view. */
export function BusinessResourceList() {
  const { resource: slug } = useParams();
  const resource = BUSINESS_RESOURCES[slug];
  if (!resource) return <Navigate to={BASE} replace />;
  return <ResourceList resource={resource} basePath={BASE} />;
}

/** /business/:resource/new — create view. */
export function BusinessResourceCreate() {
  const { resource: slug } = useParams();
  const resource = BUSINESS_RESOURCES[slug];
  if (!resource) return <Navigate to={BASE} replace />;
  return <ResourceForm resource={resource} basePath={BASE} mode="create" />;
}

/** /business/:resource/:id/edit — edit view. */
export function BusinessResourceEdit() {
  const { resource: slug } = useParams();
  const resource = BUSINESS_RESOURCES[slug];
  if (!resource) return <Navigate to={BASE} replace />;
  return <ResourceForm resource={resource} basePath={BASE} mode="edit" />;
}
